import React, { useEffect, useState } from "react";

type GeoLocationProps = {
    ip: string;
};

type LocationResult = {
    city: string;
    country: string;
};

async function fetchLocation(ip: string): Promise<LocationResult> {
    const resp = await fetch(`https://api.ipbase.com/v1/json/${ip}`);
    const data = await resp.json();
    return {
        city: data["city"],
        country: data["country_name"],
    };
}

const GeoLocation = ({ ip }: GeoLocationProps) => {
    const [city, setCity] = useState<any>(null);
    const [country, setCountry] = useState<any>(null);

    useEffect(() => {
        fetchLocation(ip).then((result) => {
            setCity(result.city);
            setCountry(result.country);
        });
    }, [ip]);

    if (country == null) return <span>{ip}</span>;
    if (city == null) return <span>{country}</span>;
    return <span>{`${city} / ${country}`}</span>;
};

export default GeoLocation;
